import type { IAgencyProfile } from '@/interfaces/agency/settings/agency/profile/index';
import axios from '@axios';

export default {
  async getAgencyProfile() {
    return await axios.get<IAgencyProfile>(`agency-info`, {
      headers: { 'x-hide-loader': true }
    });
  },

  async updateAgencyProfile(payload: Partial<IAgencyProfile>) {
    return await axios.patch(`agency-info`, payload);
  },

  async updateAgencyProfileLogos(file: File, field: string) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('field', field);

    return axios.patch(`agency-info/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
